export default __webpack_public_path__ + "static/media/logo192.2d595b5a.png";